import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';
import LoggingAppList from './LoggingAppList';


export default {
    list: LoggingAppList,
    icon: LoggingIcon
}